var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vue-admin" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "page-space" }, [
      _c("div", { staticClass: "ui secondary segment" }, [
        _c(
          "form",
          {
            class: "ui small form" + (_vm.error ? " error" : ""),
            on: {
              submit: function($event) {
                _vm.saveModel($event)
              }
            }
          },
          [
            _c("div", { staticClass: "ui grid" }, [
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" + (_vm.fieldErrors.first_name ? " error" : "")
                  },
                  [
                    _c("label", { attrs: { for: "model-first_name" } }, [
                      _vm._v("First Name")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.first_name,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.first_name,
                          expression: "model.first_name"
                        }
                      ],
                      attrs: { id: "model-first_name", required: "" },
                      domProps: { value: _vm.model.first_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "first_name", $event.target.value)
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  {
                    class: "field" + (_vm.fieldErrors.last_name ? " error" : "")
                  },
                  [
                    _c("label", { attrs: { for: "model-last_name" } }, [
                      _vm._v("Last Name")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.last_name,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.last_name,
                          expression: "model.last_name"
                        }
                      ],
                      attrs: { id: "model-last_name", required: "" },
                      domProps: { value: _vm.model.last_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "last_name", $event.target.value)
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  { class: "field" + (_vm.fieldErrors.title ? " error" : "") },
                  [
                    _c("label", { attrs: { for: "model-title" } }, [
                      _vm._v("Title")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.title,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.title,
                          expression: "model.title"
                        }
                      ],
                      attrs: { id: "model-title", required: "" },
                      domProps: { value: _vm.model.title },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "title", $event.target.value)
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  { class: "field" + (_vm.fieldErrors.type ? " error" : "") },
                  [
                    _c("label", { attrs: { for: "model-type" } }, [
                      _vm._v("Type")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: { error: _vm.fieldErrors.type, direction: "below" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-arrow" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.type,
                              expression: "model.type"
                            }
                          ],
                          attrs: { id: "model-type" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.model,
                                "type",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [_vm._v("-")]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "brokers" } }, [
                            _vm._v("Broker")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "industrial" } }, [
                            _vm._v("Industrial")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "management" } }, [
                            _vm._v("Management")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "retail" } }, [
                            _vm._v("Retail")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "team" } }, [
                            _vm._v("Team")
                          ])
                        ]
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  {
                    class: "field" + (_vm.fieldErrors.industry ? " error" : "")
                  },
                  [
                    _c("label", { attrs: { for: "model-industry" } }, [
                      _vm._v("Industry")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.industry,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-arrow" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.industry,
                              expression: "model.industry"
                            }
                          ],
                          attrs: { id: "model-industry" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.model,
                                "industry",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [_vm._v("-")]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "investment" } }, [
                            _vm._v("Capital Markets")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "industrial" } }, [
                            _vm._v("Industrial")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "office" } }, [
                            _vm._v("Office")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "retail" } }, [
                            _vm._v("Retail")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "multifamily" } }, [
                            _vm._v("Multifamily")
                          ])
                        ]
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  {
                    class: "field" + (_vm.fieldErrors.location ? " error" : "")
                  },
                  [
                    _c("label", { attrs: { for: "model-location" } }, [
                      _vm._v("Location")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.location,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-arrow" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.location,
                              expression: "model.location"
                            }
                          ],
                          attrs: { id: "model-location", required: "" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.model,
                                "location",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "Oklahoma City" } }, [
                            _vm._v("Oklahoma City")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Tulsa" } }, [
                            _vm._v("Tulsa")
                          ])
                        ]
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c("div", { staticClass: "ui segment secondary" }, [
                  _c("label", [_vm._v("Photo")]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: "field" + (_vm.fieldErrors.photo ? " error" : "")
                    },
                    [
                      _c("error-tag", {
                        attrs: {
                          error: _vm.fieldErrors.photo,
                          direction: "below"
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        ref: "photopicker",
                        attrs: { type: "file", id: "model-photo-upload" },
                        on: { change: _vm.imagePreview }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui grid" }, [
                    _c(
                      "div",
                      { staticClass: "eight wide column" },
                      [
                        _c("choose-file", {
                          attrs: { folder: "people", photo_only: true },
                          on: { picked: _vm.chooseExistingFile }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "ui divider" }),
                        _vm._v(" "),
                        _vm.model.photo || _vm.photoUpload
                          ? _c(
                              "button",
                              {
                                staticClass: "ui small grey button",
                                attrs: { type: "button" },
                                on: { click: _vm.clearPhoto }
                              },
                              [
                                _c("i", { staticClass: "erase icon" }),
                                _vm._v(" Clear photo")
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "eight wide column" }, [
                      _c("img", {
                        attrs: {
                          alt: "default",
                          src: _vm.photoUpload
                            ? _vm.photoUpload.preview
                            : _vm.model.photo
                              ? _vm.model.photo.folder + _vm.model.photo.file
                              : "/img/default.jpg?v=1"
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  { class: "field" + (_vm.fieldErrors.vcard ? " error" : "") },
                  [
                    _c("label", { attrs: { for: "model-vcard" } }, [
                      _vm._v("vCard")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.vcard,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "vcard",
                      attrs: { id: "model-vcard", type: "file", accept: ".vcf" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" + (_vm.fieldErrors.office_phone ? " error" : "")
                  },
                  [
                    _c("label", { attrs: { for: "model-office_phone" } }, [
                      _vm._v("Office Phone")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.office_phone,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.office_phone,
                          expression: "model.office_phone"
                        }
                      ],
                      attrs: { id: "model-office_phone" },
                      domProps: { value: _vm.model.office_phone },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.model,
                            "office_phone",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" + (_vm.fieldErrors.cell_phone ? " error" : "")
                  },
                  [
                    _c("label", { attrs: { for: "model-cell_phone" } }, [
                      _vm._v("Cell Phone")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.cell_phone,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.cell_phone,
                          expression: "model.cell_phone"
                        }
                      ],
                      attrs: { id: "model-cell_phone" },
                      domProps: { value: _vm.model.cell_phone },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "cell_phone", $event.target.value)
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  { class: "field" + (_vm.fieldErrors.email ? " error" : "") },
                  [
                    _c("label", { attrs: { for: "model-email" } }, [
                      _vm._v("Email Address")
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.email,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.email,
                          expression: "model.email"
                        }
                      ],
                      attrs: { id: "model-email", type: "email" },
                      domProps: { value: _vm.model.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "email", $event.target.value)
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "eight wide column" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" +
                      (_vm.fieldErrors.custom_property_url ? " error" : "")
                  },
                  [
                    _c(
                      "label",
                      { attrs: { for: "model-custom_property_url" } },
                      [_vm._v("Custom Property URL")]
                    ),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.custom_property_url,
                        direction: "below"
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.custom_property_url,
                          expression: "model.custom_property_url"
                        }
                      ],
                      attrs: { id: "model-custom_property_url" },
                      domProps: { value: _vm.model.custom_property_url },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.model,
                            "custom_property_url",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: "field" + (_vm.fieldErrors.description ? " error" : "")
              },
              [
                _c("label", { attrs: { for: "model-description" } }, [
                  _vm._v("Description")
                ]),
                _vm._v(" "),
                _c("error-tag", {
                  attrs: {
                    error: _vm.fieldErrors.description,
                    direction: "below"
                  }
                }),
                _vm._v(" "),
                _c("ckeditor", {
                  attrs: { id: "model-description" },
                  model: {
                    value: _vm.model.description,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "description", $$v)
                    },
                    expression: "model.description"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ui segments" }, [
              _c("div", { staticClass: "ui segment" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" + (_vm.fieldErrors.middle_section ? " error" : "")
                  },
                  [
                    _c("div", { staticClass: "ui toggle checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.middle_section.show,
                            expression: "model.middle_section.show"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "model-show_middle_section"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.model.middle_section.show)
                            ? _vm._i(_vm.model.middle_section.show, null) > -1
                            : _vm.model.middle_section.show
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.model.middle_section.show,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.model.middle_section.show = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.model.middle_section.show = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.model.middle_section, "show", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "check",
                          attrs: { for: "model-show_middle_section" }
                        },
                        [_vm._v("Show Middle Section")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.middle_section,
                        direction: "left"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.model.middle_section.show
                ? _c("div", { staticClass: "ui segment secondary" }, [
                    _c(
                      "div",
                      {
                        class:
                          "field" +
                          (_vm.fieldErrors.middle_section_title ? " error" : "")
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "model-middle_section_title" } },
                          [_vm._v("Middle Section Title")]
                        ),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.middle_section_title,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.middle_section.title,
                              expression: "model.middle_section.title"
                            }
                          ],
                          attrs: { id: "model-middle_section_title" },
                          domProps: { value: _vm.model.middle_section.title },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.model.middle_section,
                                "title",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("table", { staticClass: "ui celled table" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.model.middle_section.cards, function(
                          card,
                          index
                        ) {
                          return _c("tr", [
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: card.title,
                                    expression: "card.title"
                                  }
                                ],
                                domProps: { value: card.title },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(card, "title", $event.target.value)
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: card.subtitle,
                                    expression: "card.subtitle"
                                  }
                                ],
                                domProps: { value: card.subtitle },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      card,
                                      "subtitle",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("i", {
                                staticClass:
                                  "add circle icon green large clickable",
                                on: {
                                  click: function($event) {
                                    _vm.addCardAfter(index)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.model.middle_section.cards.length > 1
                                ? _c("i", {
                                    staticClass:
                                      "minus circle icon red large clickable",
                                    on: {
                                      click: function($event) {
                                        _vm.removeCard(index)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ])
                        })
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui segments" }, [
              _c("div", { staticClass: "ui segment" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" +
                      (_vm.fieldErrors.additional_section ? " error" : "")
                  },
                  [
                    _c("div", { staticClass: "ui toggle checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.additional_section.show,
                            expression: "model.additional_section.show"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "model-additional_section"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.model.additional_section.show
                          )
                            ? _vm._i(_vm.model.additional_section.show, null) >
                              -1
                            : _vm.model.additional_section.show
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.model.additional_section.show,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.model.additional_section.show = $$a.concat(
                                    [$$v]
                                  ))
                              } else {
                                $$i > -1 &&
                                  (_vm.model.additional_section.show = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(
                                _vm.model.additional_section,
                                "show",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "check",
                          attrs: { for: "model-additional_section" }
                        },
                        [_vm._v("Show Additional Section")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.additional_section,
                        direction: "left"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.model.additional_section.show
                ? _c("div", { staticClass: "ui segment secondary" }, [
                    _c(
                      "div",
                      {
                        class:
                          "field" +
                          (_vm.fieldErrors.additional_section_title
                            ? " error"
                            : "")
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "model-additional_section_title" } },
                          [_vm._v("Additional Section Title")]
                        ),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.additional_section_title,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.additional_section.title,
                              expression: "model.additional_section.title"
                            }
                          ],
                          attrs: { id: "model-additional_section_title" },
                          domProps: {
                            value: _vm.model.additional_section.title
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.model.additional_section,
                                "title",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class:
                          "field" +
                          (_vm.fieldErrors.additional_section_body
                            ? " error"
                            : "")
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "model-additional_section_body" } },
                          [_vm._v("Additional Section")]
                        ),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.additional_section_body,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("ckeditor", {
                          attrs: { id: "model-additional_section_body" },
                          model: {
                            value: _vm.model.additional_section.body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.model.additional_section,
                                "body",
                                $$v
                              )
                            },
                            expression: "model.additional_section.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui segments" }, [
              _c("div", { staticClass: "ui segment" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" +
                      (_vm.fieldErrors.investment_section ? " error" : "")
                  },
                  [
                    _c("div", { staticClass: "ui toggle checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.investment_section.show,
                            expression: "model.investment_section.show"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "model-show_investment_section"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.model.investment_section.show
                          )
                            ? _vm._i(_vm.model.investment_section.show, null) >
                              -1
                            : _vm.model.investment_section.show
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.model.investment_section.show,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.model.investment_section.show = $$a.concat(
                                    [$$v]
                                  ))
                              } else {
                                $$i > -1 &&
                                  (_vm.model.investment_section.show = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(
                                _vm.model.investment_section,
                                "show",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "check",
                          attrs: { for: "model-show_investment_section" }
                        },
                        [_vm._v("Show Investment Section")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.investment_section,
                        direction: "left"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.model.investment_section.show
                ? _c("div", { staticClass: "ui segment secondary" }, [
                    _c(
                      "div",
                      {
                        class:
                          "field" +
                          (_vm.fieldErrors.investment_section_title
                            ? " error"
                            : "")
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "model-investment_section_title" } },
                          [_vm._v("Investment Section Title")]
                        ),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.investment_section_title,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.investment_section.title,
                              expression: "model.investment_section.title"
                            }
                          ],
                          attrs: { id: "model-investment_section_title" },
                          domProps: {
                            value: _vm.model.investment_section.title
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.model.investment_section,
                                "title",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("label", [_vm._v("Investments Table Titles")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ui horizontal segments" },
                      _vm._l(_vm.model.investment_section.headers, function(
                        header,
                        index
                      ) {
                        return _c(
                          "div",
                          { staticClass: "ui segment flex-center" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.model.investment_section.headers[index],
                                  expression:
                                    "model.investment_section.headers[index]"
                                }
                              ],
                              attrs: { placeholder: "Column " + (index + 1) },
                              domProps: {
                                value:
                                  _vm.model.investment_section.headers[index]
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.model.investment_section.headers,
                                    index,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "narrow" }, [
                              _c("i", {
                                staticClass:
                                  "add circle icon green large clickable",
                                on: {
                                  click: function($event) {
                                    _vm.addInvestmentHeaderAfter(index)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.model.investment_section.headers.length > 1
                                ? _c("i", {
                                    staticClass:
                                      "minus circle icon red large clickable",
                                    on: {
                                      click: function($event) {
                                        _vm.removeInvestmentHeader(index)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        )
                      })
                    ),
                    _vm._v(" "),
                    _c("label", [_vm._v("Investments")]),
                    _vm._v(" "),
                    _c("table", { staticClass: "ui celled table" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _vm._l(
                              _vm.model.investment_section.headers,
                              function(header, column) {
                                return _c("th", [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        header
                                          ? header
                                          : "Column " + (column + 1)
                                      ) +
                                      "\n                                "
                                  )
                                ])
                              }
                            ),
                            _vm._v(" "),
                            _c("th")
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.model.investment_section.rows, function(
                          row,
                          index
                        ) {
                          return _c(
                            "tr",
                            [
                              _vm._l(
                                _vm.model.investment_section.headers,
                                function(header, column) {
                                  return _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.model.investment_section.rows[
                                              index
                                            ][column],
                                          expression:
                                            "model.investment_section.rows[index][column]"
                                        }
                                      ],
                                      domProps: {
                                        value:
                                          _vm.model.investment_section.rows[
                                            index
                                          ][column]
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.model.investment_section.rows[
                                              index
                                            ],
                                            column,
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                }
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c("i", {
                                  staticClass:
                                    "add circle icon green large clickable",
                                  on: {
                                    click: function($event) {
                                      _vm.addInvestmentRowAfter(index)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm.model.investment_section.rows.length > 1
                                  ? _c("i", {
                                      staticClass:
                                        "minus circle icon red large clickable",
                                      on: {
                                        click: function($event) {
                                          _vm.removeInvestmentRow(index)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ])
                            ],
                            2
                          )
                        })
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui segments" }, [
              _c("div", { staticClass: "ui segment" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" +
                      (_vm.fieldErrors.featured_properties ? " error" : "")
                  },
                  [
                    _c("div", { staticClass: "ui toggle checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.featured_properties.show,
                            expression: "model.featured_properties.show"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "model-featured_properties"
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.model.featured_properties.show
                          )
                            ? _vm._i(_vm.model.featured_properties.show, null) >
                              -1
                            : _vm.model.featured_properties.show
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.model.featured_properties.show,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.model.featured_properties.show = $$a.concat(
                                    [$$v]
                                  ))
                              } else {
                                $$i > -1 &&
                                  (_vm.model.featured_properties.show = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(
                                _vm.model.featured_properties,
                                "show",
                                $$c
                              )
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "check",
                          attrs: { for: "model-featured_properties" }
                        },
                        [_vm._v("Show Featured Properties")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.featured_properties,
                        direction: "left"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.model.featured_properties.show
                ? _c("div", { staticClass: "ui segment secondary" }, [
                    _c(
                      "div",
                      {
                        class:
                          "field" +
                          (_vm.fieldErrors.featured_properties ? " error" : "")
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "model-featured_properties_title" } },
                          [_vm._v("Featured Properties Title")]
                        ),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.featured_properties_title,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.featured_properties.title,
                              expression: "model.featured_properties.title"
                            }
                          ],
                          attrs: { id: "model-featured_properties_title" },
                          domProps: {
                            value: _vm.model.featured_properties.title
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.model.featured_properties,
                                "title",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class:
                          "field" +
                          (_vm.fieldErrors.featured_properties_body
                            ? " error"
                            : "")
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "model-featured_properties_body" } },
                          [_vm._v("Featured Properties")]
                        ),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.featured_properties_body,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("ckeditor", {
                          attrs: { id: "model-featured_properties_body" },
                          model: {
                            value: _vm.model.featured_properties.body,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.model.featured_properties,
                                "body",
                                $$v
                              )
                            },
                            expression: "model.featured_properties.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui segments" }, [
              _c("div", { staticClass: "ui segment" }, [
                _c(
                  "div",
                  {
                    class:
                      "field" + (_vm.fieldErrors.external_links ? " error" : "")
                  },
                  [
                    _c("div", { staticClass: "ui toggle checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.external_links.show,
                            expression: "model.external_links.show"
                          }
                        ],
                        attrs: { type: "checkbox", id: "model-external_links" },
                        domProps: {
                          checked: Array.isArray(_vm.model.external_links.show)
                            ? _vm._i(_vm.model.external_links.show, null) > -1
                            : _vm.model.external_links.show
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.model.external_links.show,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.model.external_links.show = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.model.external_links.show = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.model.external_links, "show", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "check",
                          attrs: { for: "model-external_links" }
                        },
                        [_vm._v("Show External Links")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("error-tag", {
                      attrs: {
                        error: _vm.fieldErrors.external_links,
                        direction: "left"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.model.external_links.show
                ? _c("div", { staticClass: "ui segment secondary" }, [
                    _c(
                      "div",
                      {
                        class:
                          "field" +
                          (_vm.fieldErrors.external_links ? " error" : "")
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "model-external_links_title" } },
                          [_vm._v("External Links Title")]
                        ),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.external_links_title,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.model.external_links.title,
                              expression: "model.external_links.title"
                            }
                          ],
                          attrs: { id: "model-external_links_title" },
                          domProps: { value: _vm.model.external_links.title },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.model.external_links,
                                "title",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class:
                          "field" +
                          (_vm.fieldErrors.external_links_body ? " error" : "")
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "model-external_links_body" } },
                          [_vm._v("External Links")]
                        ),
                        _vm._v(" "),
                        _c("error-tag", {
                          attrs: {
                            error: _vm.fieldErrors.external_links_body,
                            direction: "below"
                          }
                        }),
                        _vm._v(" "),
                        _c("ckeditor", {
                          attrs: { id: "model-external_links_body" },
                          model: {
                            value: _vm.model.external_links.body,
                            callback: function($$v) {
                              _vm.$set(_vm.model.external_links, "body", $$v)
                            },
                            expression: "model.external_links.body"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.error
              ? _c("error-display", { attrs: { error: _vm.error } })
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _c(
                "button",
                {
                  class:
                    "ui small green submit button" +
                    (_vm.saving ? " loading " : ""),
                  attrs: { type: "submit" }
                },
                [_vm._v("Save Person")]
              )
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-banner" }, [
      _c("h1", [_vm._v("Add Person — Admin")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v("Recommended file size is 500px wide by 334px tall.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subtitle")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08317e75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08317e75","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin/people/create.vue
// module id = 551
// module chunks = 0